import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html {
    position: relative;
    height: 100%;
    overflow-x: hidden;

    #root {
      height: 100%;

      & > div {
        height: 100%;
      }
    }
  }

  *,
  ::before,
  ::after {
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    font-family: 'Montserrat', sans-serif;
    padding-top: env(safe-area-inset-top), constant(safe-area-inset-top); // we need this for iphone notch
    margin: 0;
    overscroll-behavior: none;
  }
`;
